<template>
  <div id="ballast">
    <div class="vx-card p-1" style="height:30rem;">
      <div class="flex flex-wrap items-center mb-base" style="padding: 0.25rem;">
        <div class="flex-grow">
          <div class="category-name aisea-text-14-400-black">バラスト</div>
          <div class="ballast-tanks">
            <vs-row style="width:45rem;height:25rem;">
              <div
                v-for="(data, index) in tankData"
                :key="index"
                style="width:4.5rem;height:25rem;"
              >
                <vs-col
                  v-if="data.key === 'C'"
                  class="flex justify-center items-center"
                  style="width:4.5rem;height:25rem;"
                >
                  <div v-for="(d, index) in data.data" :key="index">
                    <tank-name
                      v-if="d.name === 'FPT'"
                      :name="d.name"
                      class="aisea-text-14-400-black"
                      style="padding-top: 22px"
                    ></tank-name>
                    <tank-name
                      v-else-if="d.name === 'APT'"
                      :name="d.name"
                      class="aisea-text-14-400-black"
                      style="padding-top: 22px"
                    ></tank-name>
                    <tank-name
                      v-else
                      :name="d.name"
                      class="aisea-text-14-400-black"
                    ></tank-name>
                    <tank-gauge
                      :background="AISEA_COLOR.BLUE"
                      :percentage="d.percentage"
                      :upperLimit="d.upperLimit"
                      :lowerLimit="d.lowerLimit"
                    ></tank-gauge>
                    <tank-info
                      :level="d.vn"
                      :tonn="d.vs"
                      :fontColor="fontColor"
                      class="aisea-text-14-400-black"
                    ></tank-info>
                  </div>
                </vs-col>
                <vs-col v-else style="width:4.5rem;height:25rem;">
                  <div
                    v-for="(d, index) in data.data"
                    :key="index"
                    class="tank-col flex  justify-center items-center"
                    style="width:4.5rem;height:10rem;margin-bottom:4.5rem;"
                  >
                    <tank-name
                      :name="d.name"
                      class="aisea-text-14-400-black"
                    ></tank-name>
                    <tank-gauge
                      :background="AISEA_COLOR.BLUE"
                      :percentage="d.percentage"
                      :upperLimit="d.upperLimit"
                      :lowerLimit="d.lowerLimit"
                    ></tank-gauge>
                    <tank-info
                      :level="d.vn"
                      :tonn="d.vs"
                      :fontColor="fontColor"
                      class="aisea-text-14-400-black"
                    ></tank-info>
                  </div>
                </vs-col>
              </div>
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TankGauge from "./TankGauge.vue";
import TankInfo from "./TankInfo.vue";
import TankName from "./TankName.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("ecoShip");
import { ColorMixin } from "@/mixins";

export default {
  components: { TankName, TankGauge, TankInfo },
  mixins: [ColorMixin],
  props: {
    vesselId: { type: String },
    data: { type: Object },
    fontColor: { type: String },
  },
  data() {
    return {
      version: {},
      tankData: []
    };
  },
  watch: {
    levelGaugeLastUpdatedAt() {
      this.setTankData(this.tankData);
    }
  },
  created() {
    this.getChannels();
  },
  computed: {
    ...mapState({
      versionName: state => state.kind.level_gauge.versionName,
      levelGauge: state => state.levelGauge,
      levelGaugeDashboard: state => state.levelGaugeDashboard,
      levelGaugeLastUpdatedAt: state => state.levelGaugeLastUpdatedAt
    })
  },
  methods: {
    ...mapActions([
      "fetchLevelGaugeDashboard",
      "unsubscribeFirestore"
    ]),
    async getChannels() {

      let payload = {
        enterprise_id: this.$store.state.auth.user.id,
        vessel_id: this.vesselId,
        name: this.versionName
      }

      let dashboard = await this.fetchLevelGaugeDashboard(payload);

      let dashboardList = dashboard["ballastList"].data;
      let data4 = [];
      let data5 = [];
      let data6 = [];
      let data7 = [];
      let data8 = [];
      let aptData = [];
      dashboardList.forEach(d => {
          if (d.label.indexOf("No.4") != -1) {
          data4.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else if (d.label.indexOf("No.5") != -1) {
          data5.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else if (d.label.indexOf("No.6") != -1) {
          data6.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else if (d.label.indexOf("No.7") != -1) {
          data7.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else if (d.label.indexOf("No.8") != -1) {
          data8.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else if (d.label.indexOf("APT") != -1) {
          aptData.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
        } else {
          let centerData = [];
          centerData.push({
            name: d.label,
            vn: null,
            vs: null,
            percentage: null,
            upperLimit: null,
            lowerLimit: null,
            maxId: d.max.channel_id,
            valueId: d.value.channel_id,
            upperLimitId: d.upper_limit.channel_id,
            lowerLimitId: d.lower_limit.channel_id,
            weightId: d.weight.channel_id,
          });
          this.tankData.push({
            data: centerData,
            key: "C",
            sort: d.sort
          });
        }
        });
      this.tankData.push({ data: data4, key: "PS" });
      this.tankData.push({ data: data5, key: "PS" });
      this.tankData.push({ data: data6, key: "PS" });
      this.tankData.push({ data: data7, key: "PS" });
      this.tankData.push({ data: data8, key: "PS" });
      this.tankData.push({ data: aptData, key: "C" });

      this.setTankData(this.tankData.reverse());
    },
    setTankData(tankData) {
      let data2 = [];
      data2.push(this.data[this.vesselId]);

      tankData.forEach(m => {
        m.data.forEach(d => {
          data2.forEach(e => {
            let max = null;
            if (d.maxId in e) {
              max = e[d.maxId].vn;
            }
            if (d.valueId in e) {
              const vn = e[d.valueId].vn / 100;
              d.vn = vn.toFixed(2);
              d.percentage = e[d.valueId].vn / max;
            }
            if (d.upperLimitId in e) {
              d.upperLimit = e[d.upperLimitId].vn / max;
            }
            if (d.lowerLimitId in e) {
              d.lowerLimit = e[d.lowerLimitId].vn / max;
            }
            if (d.weightId in e) {
              const vn = e[d.weightId].vn / 10;
              d.vs = vn.toFixed(1);
            }
          });
        });
      });
    },
  },
  beforeDestroy() {
    this.unsubscribeFirestore();
  }
};
</script>

<style lang="scss">
#ballast {
  .vx-card {
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,.1);
  }
  .category-name {
    display: flex;
    padding: 5px;
    align-items: center;
  }
  .ballast-tanks {
    padding: 5px 10px;
    text-align: center;
  }
  .tank-row {
    align-items: center;
  }
  .tank-col {
    flex-direction: column;
  }
}
</style>
